import { router } from '@inertiajs/vue3';

export function useCertidaoNavigation() {
    const getEmissaoCertidoesRoute = () => route('emissao-certidoes');

    const goToEmissaoCertidoes = () => router.visit(getEmissaoCertidoesRoute());

    return { getEmissaoCertidoesRoute, goToEmissaoCertidoes };
}
